export default function AppSection() {
  return (
    <section id="app" className="relative py-14 md:py-20 bg-background-900/60 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(ellipse_at_top_right,_oklch(var(--primary-500))_0%,_transparent_50%)]"></div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="text-xs md:text-sm text-accent-400 font-medium tracking-wider uppercase mb-2">Mobile Experience</p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">移动端体验</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed max-w-lg mx-auto lg:mx-0">
              妖精视频全面适配移动端浏览体验。无论是地铁通勤、午休摸鱼还是睡前放松，随时随地打开手机就能畅享红桃视频、小蓝视频、黑桃视频等数字颜色系列全频道高清内容。横竖屏自由切换，手势操作流畅，流量优化省带宽。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
              <div className="flex items-center gap-3 px-5 py-3 bg-background-800/60 border border-background-600/40 rounded-lg">
                <i className="ri-android-line text-2xl text-accent-400"></i>
                <div className="text-left">
                  <p className="text-xs text-foreground-600">Android 版</p>
                  <p className="text-sm font-medium text-foreground-300">浏览器直接访问</p>
                </div>
              </div>
              <div className="flex items-center gap-3 px-5 py-3 bg-background-800/60 border border-background-600/40 rounded-lg">
                <i className="ri-apple-line text-2xl text-accent-400"></i>
                <div className="text-left">
                  <p className="text-xs text-foreground-600">iOS 版</p>
                  <p className="text-sm font-medium text-foreground-300">Safari 添加到桌面</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[360px] relative">
            <div className="relative mx-auto w-[220px] h-[440px] bg-background-800/80 rounded-[32px] border-4 border-background-600/50 overflow-hidden shadow-2xl">
              <div className="absolute top-0 left-0 right-0 h-7 bg-background-700/80 flex items-center justify-center">
                <div className="w-16 h-1 rounded-full bg-background-500/60"></div>
              </div>
              <div className="pt-7 h-full flex flex-col">
                <div className="px-3 py-2 bg-background-700/40 mx-2 mt-2 rounded-lg flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center text-primary-400 text-xs font-bold">妖</div>
                  <div className="flex-1">
                    <p className="text-[10px] font-medium text-foreground-300">妖精视频</p>
                    <p className="text-[8px] text-foreground-600">数字颜色系列</p>
                  </div>
                </div>
                <div className="flex-1 flex flex-col gap-1.5 px-2 mt-3 overflow-hidden">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="flex items-center gap-2 bg-background-700/30 rounded-md p-1.5">
                      <div className="w-14 h-9 rounded bg-background-600/50 flex items-center justify-center text-[8px] text-foreground-600">预览</div>
                      <div className="flex-1 truncate">
                        <p className="text-[9px] text-foreground-300 truncate">数字颜色系列视频标题</p>
                        <p className="text-[7px] text-foreground-600">12.5万次</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="px-3 py-2 flex items-center justify-around bg-background-700/60">
                  <i className="ri-home-5-line text-sm text-primary-400"></i>
                  <i className="ri-search-line text-sm text-foreground-600"></i>
                  <i className="ri-compass-3-line text-sm text-foreground-600"></i>
                  <i className="ri-user-line text-sm text-foreground-600"></i>
                </div>
              </div>
            </div>
            <div className="absolute -top-6 -right-6 md:-right-8 hidden md:flex items-center gap-2 bg-primary-500/20 backdrop-blur-sm px-4 py-2 rounded-lg border border-primary-500/20">
              <span className="text-xs text-primary-300 font-medium">移动端适配完成</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}